function i(e) {
  return e.filter(Boolean).join(", ") || "";
}
function l(e) {
  if (e) {
    const { street: r, city: o, state: s, zipCode: u, country: c } = e, t = i([r || "", o || ""]), n = i([
      s || "",
      u || "",
      c || ""
    ]);
    return {
      line1: t || n,
      line2: t ? n : ""
    };
  }
  return {
    line1: "",
    line2: ""
  };
}
export {
  l as default
};
